import type { UIMessage } from '@ai-sdk/react';
import ChartsDataTool from '../tools/ChartsDataTool';
import FileTool from '../tools/FileTools';
import PerformanceDataTool from '../tools/PerformanceDataTool';
import VehiclesListTool from '../tools/VehiclesListTool';
import type { ChatMessagePart } from './utils';

const AssistantToolResult = ({ part }: { part: ChatMessagePart }) => {
  switch (part.type) {
    case 'tool-vehiclesListTool':
      return <VehiclesListTool part={part} />;
    case 'tool-code_execution':
      return <FileTool part={part} />;
    case 'tool-performanceDataTool':
      return <PerformanceDataTool part={part} />;
    case 'tool-chartsDataTool':
      return <ChartsDataTool part={part} />;
    default:
      return null;
  }
};

const AssistantToolResults = ({ message }: { message: UIMessage }) => (
  <div>
    {(message.parts as ChatMessagePart[]).map((part, index) => (
      <AssistantToolResult key={`${message.id}-${index}-${part.type}`} part={part} />
    ))}
  </div>
);

export default AssistantToolResults;
